import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import FormControl from "@material-ui/core/FormControl";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverTagsActions from "../../../store/actions/DriverTags";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  fieldsMargin: {
    margin: "10px 0",
  },
  info: {
    color: "red",
    margin: "10px 0",
  },
}));

const driverTags = [
  "ACCOUNTING",
  "ACCOUNTING_STRATEGY",
  "MING_TAG",
  "INCENTIVE",
];

const DriverTagsMappingFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeFiltersDriverTagsMappings,
    driverTagsList,
    getDriverTagsList,
    nextPage,
    getDriverTag,
    mappingType,
  } = props;
  const classes = useStyles();
  const [initialState, setInitialState] = useState({
    driver_id: "",
    tag_id: "",
    target_date: "",
    tag_types: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    let filters = {};
    Object.keys(initialState).map((state) => {
      if (initialState[state] !== "") {
        filters[state] = initialState[state];
      }
    });
    props
      .getDriverTagsMappingList(
        filters,
        {},
        mappingType === "other" ? "OTHER" : "ACCOUNTING"
      )
      .then((res) => {
        handleClose();
      });
  };

  const handleClearFilters = () => {
    props
      .getDriverTagsMappingList(
        {},
        {},
        mappingType === "other" ? "OTHER" : "ACCOUNTING"
      )
      .then((res) => {
        handleClose();
      });
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const getAdditionalParams = () => {
    if (mappingType === "other") {
      return ["OTHER"];
    } else {
      return ["ACCOUNTING", "ACCOUNTING_STRATEGY", "MING_TAG", "INCENTIVE"];
    }
  };

  useEffect(() => {
    //set the initial state of form in modal
    if (activeFiltersDriverTagsMappings && modalState) {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFiltersDriverTagsMappings[key]
          ? activeFiltersDriverTagsMappings[key]
          : "";
      });
      setInitialState(values);
    }
  }, [activeFiltersDriverTagsMappings]);

  return (
    <NoFooterModal
      header={true}
      heading="Apply Filters"
      handleClose={handleClose}
      id="DriverTagsMappingOtherFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <Input
        value={initialState.driver_id}
        data-testid="driverId"
        id="sushi-input"
        onChange={(e) => handleChange("driver_id", e)}
        label="Driver Id (Starts with FE)"
      />
      <Input
        id="sushi-input"
        fullWidth={true}
        value={initialState.target_date}
        label="Enter Target Date"
        type="date"
        onChange={(e) => handleChange("target_date", e)}
      />
      {mappingType === "accounting" && (
        <PaginatedReactDropdown
          options={driverTags}
          data-testid="tagType"
          value={initialState.tag_types}
          labelWidth="10%"
          handleChange={handleChange}
          keyToChange="tag_types"
          placeholder="Tag Type"
          showCross={false}
          id="tagMappingTypeDropdown"
        />
      )}
      <FormControl
        fullWidth
        className={classes.fieldsMargin}
        variant="outlined"
      >
        <InfiniteScrollDropdown
          priorityFlag={true}
          getActiveList={getDriverTagsList}
          additionalParams={getAdditionalParams()}
          appliedFilters={{}}
          nextPage={nextPage}
          resKey="data"
          modalState={modalState}
          keyName="tag_id"
          labelKey="name"
          keyTypeToSet="id"
          disabled={false}
          label="Tag Name"
          getDataLabelKey="tag.name"
          handleChange={handleChange}
          remoteSearchApplicable={true}
          remoteSearchKey="name"
          activeFilters={activeFiltersDriverTagsMappings}
          getActiveItemById={getDriverTag}
        />
      </FormControl>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { DriverTags } = state;
  return {
    activeFiltersDriverTagsMappings: DriverTags.activeFiltersDriverTagsMappings,
    nextPage: DriverTags.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverTagsMappingList: bindActionCreators(
      DriverTagsActions.getDriverTagsMappingList,
      dispatch
    ),
    getDriverTagsList: bindActionCreators(
      DriverTagsActions.getDriverTagsList,
      dispatch
    ),
    resetState: bindActionCreators(DriverTagsActions.resetState, dispatch),
    getDriverTag: bindActionCreators(DriverTagsActions.getDriverTag, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverTagsMappingFormModal);
